import ToastWrapper from "@/components/elements/ToastOnLoad/ToastOnLoad";
import ReactDOM from "react-dom";

const ToastOnLoadPortal = () =>  {


        //if acknowledgements is enabled, get the target container.
        let targetContainer = document.getElementById('react-toast-portal');
        if (!targetContainer) {
                //if there is nowhere for the portal, do not display
                return null;

        } else {
                return ReactDOM.createPortal(
                    <ToastWrapper />,
                    targetContainer
                );
        }
} 

export default ToastOnLoadPortal;
